module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg music",
    class: _vm.data ? '' : 'c'
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9da40cdc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/music/index.vue
// module id = 143
// module chunks = 1